(ns practitest.frontend.testset2.linked-issues-grid
  (:require
   [practitest.frontend.components2.issue-status :as issue-status]))

(defn get-linked-issues-columns [priority-col users]
  (remove nil?
          [{:type          :display_id
            :field         :display_id
            :systemcol?    true
            :default-width 80
            :default-show? true
            :header        "ID"
            :sortable?     true
            :autofilter?   true}
           {:type          :url
            :field         :title
            :systemcol?    true
            :default-width 280
            :default-show? true
            :header        "Title"
            :sortable?     true
            :autofilter?   true}
           {:type            :list
            :field           :issue_status
            :possible-values (vec (keys issue-status/statuses-map))
            :multiple?       true
            :systemcol?      true
            :default-width   120
            :default-show?   true
            :header          "Status"
            :sortable?       true
            :autofilter?     true}
           {:type          :date-time
            :field         :created_at
            :systemcol?    true
            :default-width 160
            :default-show? true
            :header        "Created"
            :sortable?     true
            :autofilter?   true}
           priority-col
           {:type          :user
            :field         :author
            :users         users
            :systemcol?    true
            :default-width 150
            :default-show? true
            :header        "Author"
            :sortable?     true
            :autofilter?   true}]))
